import { render, staticRenderFns } from "./ZerarSaldoBancoHoras.vue?vue&type=template&id=4b196ce5&"
import script from "./ZerarSaldoBancoHoras.vue?vue&type=script&lang=js&"
export * from "./ZerarSaldoBancoHoras.vue?vue&type=script&lang=js&"
import style0 from "./ZerarSaldoBancoHoras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports